module.exports = __webpack_public_path__ + "static/media/circle.be314bc1.svg";